import { render } from "./online-sync-health-modal.vue?vue&type=template&id=01011627&scoped=true"
import script from "./online-sync-health-modal.vue?vue&type=script&lang=js"
export * from "./online-sync-health-modal.vue?vue&type=script&lang=js"

import "./online-sync-health-modal.vue?vue&type=style&index=0&id=01011627&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01011627"]])

export default __exports__